export default "__VITE_ASSET__f5bUr5YE__"